<div [formGroup]="group" [ngClass]="{ 'form-group--checkmark': control.isValid && !formControl?.disabled }">
  @switch (control.type) {
    @case (formType.date) {
      <input
        type="text"
        class="form-control"
        (keyup)="dateInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [id]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
        [attr.aria-required]="isRequired ? 'true' : 'false'"
        [attr.aria-invalid]="control.hasError ? 'true' : null"
      />
    }
    @case (formType.postalCode) {
      <input
        type="text"
        class="form-control"
        (blur)="postcodeInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [id]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
        [attr.aria-required]="isRequired ? 'true' : 'false'"
        [attr.aria-invalid]="control.hasError ? 'true' : null"
      />
    }
    @case (formType.phoneNumber) {
      <input
        type="tel"
        class="form-control"
        (blur)="phoneNumberInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [id]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
        [attr.aria-required]="isRequired ? 'true' : 'false'"
        [attr.aria-invalid]="control.hasError ? 'true' : null"
      />
    }
    @case (formType.numberOnly) {
      <input
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        class="form-control"
        (blur)="numberOnlyInputMask($event)"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [id]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
        [attr.aria-required]="isRequired ? 'true' : 'false'"
        [attr.aria-invalid]="control.hasError ? 'true' : null"
      />
    }
    @default {
      <input
        [type]="control.type"
        class="form-control"
        (blur)="config.trim ? trimTrailSpace($event) : null"
        (change)="onChange($event)"
        [formControlName]="config.name"
        [id]="config.name"
        [attr.placeholder]="config.placeholder"
        [attr.maxLength]="config.maxLength"
        [attr.autocomplete]="config.autocomplete ? config.autocomplete : null"
        [attr.aria-required]="isRequired ? 'true' : 'false'"
        [attr.aria-invalid]="control.hasError ? 'true' : null"
      />
    }
  }

  @if (showVerification) {
    <div class="form-control__badge">
      @if (isUnverified) {
        <button type="button" (click)="verify($event)" class="badge badge--button">
          <span>{{ control.verifyLabel ?? ('account.label.verify' | translate) }}</span>
          <span class="icon icon-ui-arrow--right--sm"></span>
        </button>
      }
    </div>
  }
</div>
